import { Dispatch, SetStateAction, createContext, useContext } from "react";

import { HEADER_CATEGORY } from "@@/components/header/Header";

type HeaderCategoryContext = {
	hoveredCategory: HEADER_CATEGORY | undefined
	setHoveredCategory: Dispatch<SetStateAction<HEADER_CATEGORY | undefined>>
}

export const HeaderCategoryContext = createContext<HeaderCategoryContext>({
	hoveredCategory: undefined,
	setHoveredCategory: () => undefined,
});

export const useHeaderCategoryContext = () => useContext(HeaderCategoryContext);
